import gsap from 'gsap';

export default () => {
  let htmlEl = document.documentElement;
  let cursor = document.querySelector('.cursor');
  const cursorFilledClass = 'cursor--filled';
  const cursorPlusClass = 'cursor--plus';
  const cursorMoveClass = 'cursor--move';
  const cursorLeftClass = 'cursor--swiper-l';
  const cursorRightClass = 'cursor--swiper-r';
  const cursorRightTeamClass = 'cursor--swiper-r-team';
  const iframes = document.querySelectorAll('.full-width-wrapper--iframe');

  let x = 0;
  let y = 0;

  if (cursor) {

    if (iOS() || isAndroid()) {
      let cursor = document.querySelector('.cursor');
      if (cursor) {
        cursor.remove();
      }
      return;
    }



    htmlEl.classList.add('is-loaded');

    let btns = document.querySelectorAll('a, button, .burger');
    let plusBtns = document.querySelectorAll('.cursor-plus, .project-info img');
    let moveBtns = document.querySelectorAll('.cursor-move');

    let lBtns = document.querySelectorAll('.cursor-left');
    let rBtns = document.querySelectorAll('.cursor-right');
    let rTeamsBtns = document.querySelectorAll('.cursor-right-team');

    
    if (btns.length) {
      btns.forEach(function(btn) {
        btn.addEventListener('mouseenter', (e) => {
          cursor.classList.add(cursorFilledClass);
        });
        btn.addEventListener('mouseleave', (e) => {
          cursor.classList.remove(cursorFilledClass);
        });
      });
    }

    if (iframes.length) {
      iframes.forEach(function(iframe) {
        iframe.addEventListener('mouseenter', (e) => {
          cursor.classList.add('cursor--iframe');
        });
        
        iframe.addEventListener('mouseleave', (e) => {
          cursor.classList.remove('cursor--iframe');
        });
      });
    }
    
    if (plusBtns.length) {
      // fix for slider duplicate elements
      setTimeout(function(){
        plusBtns = document.querySelectorAll('.cursor-plus, .project-info img');

        plusBtns.forEach(function(btn) {
          btn.addEventListener('mouseenter', (e) => {
            cursor.classList.add(cursorPlusClass);
          });
          btn.addEventListener('mouseleave', (e) => {
            cursor.classList.remove(cursorPlusClass);
          });
        });
      }, 200);
    }

    if (moveBtns.length) {
      setTimeout(function(){
        let moveBtns = document.querySelectorAll('.cursor-move');

        moveBtns.forEach(function(btn) {
          btn.addEventListener('mouseenter', (e) => {
            cursor.classList.add(cursorMoveClass);
          });
          btn.addEventListener('mouseleave', (e) => {
            cursor.classList.remove(cursorMoveClass);
          });
        });
      }, 200);
    }
    

    if (lBtns.length) {
      lBtns.forEach(function(btn) {
        btn.addEventListener('mouseenter', (e) => {
          cursor.classList.add(cursorLeftClass);
        });
        btn.addEventListener('mouseleave', (e) => {
          cursor.classList.remove(cursorLeftClass);
        });
      });
    }
    if (rBtns.length) {
      rBtns.forEach(function(btn) {
        btn.addEventListener('mouseenter', (e) => {
          cursor.classList.add(cursorRightClass);
        });
        btn.addEventListener('mouseleave', (e) => {
          cursor.classList.remove(cursorRightClass);
        });
      });
    }
    

    if (rTeamsBtns.length) {
      rTeamsBtns.forEach(function(btn) {
        btn.addEventListener('mouseenter', (e) => {
          cursor.classList.add(cursorRightTeamClass);
          console.log("in");
        });
        btn.addEventListener('mouseleave', (e) => {
          cursor.classList.remove(cursorRightTeamClass);
          console.log("out");
        });
      });
    }
    
    
    document.addEventListener("mousemove", e => {
      if (cursor.classList.contains('cursor--hidden')) {
        cursor.classList.remove('cursor--hidden');
      }
      x = e.clientX;
      y = e.clientY;
    });

    let slider = document.querySelector('.h-projects__slider');
    let cursor = document.querySelector('.cursor');

    if (slider && cursor) {
      slider.addEventListener('mousemove', (e) => {
        let width = slider.getBoundingClientRect().width;
        let xOffset = e.clientX - slider.getBoundingClientRect().left;
        let progress = xOffset/width;
        
        if ((progress<= 0.25 || progress >= 0.75) && e.target.classList.contains('h-projects__slide-link')) {
          cursor.classList.add('cursor--move');
        } else {
          cursor.classList.remove('cursor--move');
        }
      });

      slider.addEventListener('mouseleave', (e) => {
        cursor.classList.remove('cursor--move');
      });
    }

    const render = () => {
      gsap.to(cursor, {
        x: x,
        y: y,
        duration: 0
      });
      requestAnimationFrame(render);
    };
    render();
    requestAnimationFrame(render);
  }


  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  function isAndroid() {
    return /(android)/i.test(navigator.userAgent);
  }
}
